import { render, staticRenderFns } from "./AddToCartNotification.vue?vue&type=template&id=6f8fa0f6&scoped=true&"
import script from "./AddToCartNotification.vue?vue&type=script&lang=js&"
export * from "./AddToCartNotification.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartNotification.vue?vue&type=style&index=0&id=6f8fa0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8fa0f6",
  null
  
)

export default component.exports